import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { TenorDetails } from 'state/quotes/details/details.model';
import { QuoteResultStatus, SolveResultFormat } from 'state/quotes/results/result.model';
import type { Collection } from 'state/utils/types';
import { BaseWorkspaceTabContent } from 'state/workspaces/tabContent/tabContent.model';
import { FunctionalMessage } from 'utils/http/httpClient.model';

export type ResultStatus = 'Error' | 'StartParsing' | 'Parsed' | 'QuoteAcked' | 'QuoteReceived';
export type SmartQuoteError = FunctionalMessage<'UnsupportedPayoff'>;
export type SmartQuoteParsingResult = {
  id: string;
  status: ResultStatus;
  promptId: string;
  rfqId: string;
  confidence: number;
  solveMode?: string;
  solveResultFormat?: SolveResultFormat;
  solveResult?: number;
  quoteStatus?: QuoteResultStatus;
  underlyings?: string[];
  tenor?: TenorDetails;
  externalQuoteId?: string;
  pricingEstimatedDurationInMilliseconds?: number;
  productKey: AstroProductKey;
  currency?: string;
  negotiationId?: string;
  aiGeneratedFields?: string[];
  isDisplayedPrice?: boolean;
  error?: SmartQuoteError;
};

export type SmartQuotePromptStatus = 'Initialized' | 'Processing' | 'Finished';
export type AstroProductKey = {
  instrument: { name: string; contractName: string };
  wrapper: string;
};

export type SmartQuotePrompt = {
  id: string;
  createdAt: string;
  filename: string;
  status: SmartQuotePromptStatus;
  totalCount?: number;
  results: Collection<SmartQuoteParsingResult>;
  selectedOnBehalfClient?: ISalesCounterpart;
  pendingFile?: string;
};

export type SmartQuotePersistedTabContent = {
  promptsIds: readonly string[];
  workspace: 'smartQuote';
};

export type SmartQuotePrompts = {
  prompts: Collection<SmartQuotePrompt>;
};

export type SmartQuoteWorkspaceState = BaseWorkspaceTabContent & SmartQuotePersistedTabContent & SmartQuotePrompts;
export type SmartQuoteWorkspaceStateMap = Collection<SmartQuoteWorkspaceState>;

export const initialSmartQuoteWorkSpaceState: SmartQuoteWorkspaceStateMap = {};
